export const MAP_FALLBACK_POSITION = {
    latitude: 53.12406952303962,
    longitude: 18.001681992550445,
};
export const MAP_FIT_BOUNDS_PADDING = {
    top: 80, // px
    bottom: 80, // px
    left: 80, // px
    right: 80, // px
};
export const MAP_CLUSTER_MARKERS_DISTANCE = 50; // px
export const MAP_MAX_CLUSTER_COUNT = 100; // markers
// Max per-axis lat/lng delta below which two coordinates are treated as the same map center.
// 0.0005° ≈ 55 m at the equator and ~35 m at 50° latitude — small enough to feel "on top of"
// the user, large enough to absorb GPS jitter and panTo float-rounding.
export const MAP_CENTERED_ON_THRESHOLD_DEGREES = 0.0005;
// Colors of an area drawn on the map. Google Maps takes raw colors, not CSS variables; these are the
// `stroke-brand-light` token and white, which both stay visible on the satellite and the road map.
export const MAP_AREA_EDITABLE_COLOR = '#155dfc';
export const MAP_AREA_COLOR = '#ffffff';
export const MAP_AREA_FILL_OPACITY = 0.25;
export const MAP_AREA_STROKE_WEIGHT = 3;
